import FormInput from '@form/FormInput';
import { ActionForm } from '@form/index';
import { useTranslation } from 'react-i18next';
import useSWR from 'swr';
import { useClubSlug } from '../Clubs/hooks';
import Loader from '../Loader';
import { AllocationGroup } from './types';

interface Props {
    group: Required<Pick<AllocationGroup, 'id'>> & Partial<AllocationGroup>;
    callback?: (newGroup: AllocationGroup) => void;
}

const AllocationGroupForm = ({ group, callback }: Props) => {
    const { t } = useTranslation('space-manager');
    const clubSlug = useClubSlug();
    const { data, isLoading } = useSWR(group ? `space-manager/allocation-group/${group.id}` : null);

    return (
        <Loader isLoading={isLoading}>
            <ActionForm
                url={
                    group
                        ? `space-manager/allocation-group/${group.id}`
                        : `club/${clubSlug}/space-manager/allocation-group`
                }
                defaultValues={data?.data}
                method={group ? 'PUT' : 'POST'}
                onSuccess={(data: { data: AllocationGroup }) => callback?.(data?.data)}
            >
                <FormInput name="name" label={t('allocation.group.nameLabel')} />
                <FormInput.Color name="color" label={t('allocation.group.colorLabel')} />
                <FormInput.Checkbox
                    name="disable_iot_output_switching"
                    label={t('allocation.group.disableIotLabel')}
                />
            </ActionForm>
        </Loader>
    );
};

export default AllocationGroupForm;
